const bithidePartnerName = 'x10tn';

export {
  bithidePartnerName,
};
